import React, { useCallback, useState } from 'react';
import moment from 'moment-timezone';
import {
    Box,
    Typography,
    Button,
    IconButton,
    List,
    ListItemIcon,
    ListItem,
    ListItemText,
    LinearProgress,
    Grid
} from '@material-ui/core';
import { useStyles } from './style';
import { AVAILABLE_SECONDARY_CREDIT_TYPES } from 'constants/pricingPlan';
import SvgPlanCancelled from 'icons/SvgPlanCancelled';
import { CURRENT_SITE_BUILDER_NAME } from '../../../constants/platform';

const SecondaryPlanDetails = ({ planDetails }) => {
    const { title, mediaPlusSection, secPlanCancelledSection, secPlanTextContent } = useStyles();

    return (
        <>
            {planDetails?.plan?.isSubscriptionActive ? <Box className={mediaPlusSection}>
                <Typography className={title} color="textSecondary" component="p" variant="body2">
                    Media Sites Published
                </Typography>
                <Typography className={`${title} mediaSitesPublished`} color="textSecondary" component="p" variant="h5">
                    {`${planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE]?.consumedCreds || 0}/${(planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE]?.baseCreds || 0) + (planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_SITE]?.addOnCreds || 0)}`}
                </Typography>
                <Typography className={title} color="textSecondary" component="p" variant="body2">
                    Videos Uploaded
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                        <Typography className={`${title} mediaSitesPublished`} color="textSecondary" component="p" variant="h6">
                            {`${Math.round(((planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.consumedCreds || 0) / ((planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.baseCreds || 0) + (planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.addOnCreds || 0))) * 100)}%`}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography className={title} color="secondary" component="p" variant="subtitle2">
                            {`${planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.consumedCreds || 0}/${(planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.baseCreds || 0) + (planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.addOnCreds || 0)}`}
                        </Typography>
                    </Box>
                </Box>
                <Box className={`${title} videoUploadedPer`}>
                    <LinearProgress variant="determinate" value={Math.round(((planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.consumedCreds || 0) / ((planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.baseCreds || 0) + (planDetails?.creditUsage?.[AVAILABLE_SECONDARY_CREDIT_TYPES.MP_VIDEO]?.addOnCreds || 0))) * 100)} />
                </Box>
            </Box> : <>
                <Box className={secPlanCancelledSection}>
                    <Box>
                        <SvgPlanCancelled />
                    </Box>
                    <Box className={secPlanTextContent}>
                        <Typography className={title} color="secondary" component="p" variant="subtitle1">
                            Your {CURRENT_SITE_BUILDER_NAME} Subscription has been cancelled
                        </Typography>
                        <Typography color="textSecondary" component="p" variant="body2">
                            Talk to our sales team to activate your subscription.
                        </Typography>
                        <Typography color="textSecondary" component="p" variant="body2">
                            You won’t be able to add any media or forms and your media sites will be unpublished
                        </Typography>
                    </Box>
                </Box>
            </>}
        </>);
}


export default SecondaryPlanDetails;